export const TOAST_MESSAGES = {
    FETCH_ANNOUNCEMENT_FAILED: "Failed to fetch announcements",
    FETCH_ANNOUNCEMENT_ERROR: "Error fetching announcements",
    ADD_ANNOUNCEMENT_SUCCESS: "Announcement added successfully",
    ADD_ANNOUNCEMENT_FAILED: "Failed to add announcement",
    ADD_ANNOUNCEMENT_ERROR: "Error adding announcement",
    UPDATE_ANNOUNCEMENT_SUCCESS: "Announcement updated successfully",
    UPDATE_ANNOUNCEMENT_FAILED: "Failed to update announcement",
    UPDATE_ANNOUNCEMENT_ERROR: "Error updating announcement",
    DELETE_ANNOUNCEMENT_SUCCESS: "Announcement deleted successfully",
    DELETE_ANNOUNCEMENT_FAILED: "Failed to delete announcement",
    DELETE_ANNOUNCEMENT_ERROR: "Error deleting announcement",
}

export const ANNOUNCEMENT_COLUMNS = [
  "title",
  "redirect_url",
  "start_date",
  "end_date",
  "status",
  "actions"
];

export const ANNOUNCEMENT_LABELS = {
  title: "Title",
  redirect_url: "Redirect URL",
  start_date: "Start Date",
  end_date: "End Date",
  status: "Status",
  actions: "Actions"
};


export const STATUS_TYPES = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const COLUMN_WIDTHS = {
  title: "w-48",        
  redirect_url: "w-40", 
  start_date: "w-32",   
  end_date: "w-32",     
  status: "w-28",       
  actions: "w-32",      
};
